import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { bulkIncreaseStudentGrade, fetchStudents } from "../studentSlice";
import GradeIncreasePreviewModal from "./GradeIncreasePreviewModal";
import GradeIncreaseConfirmModal from "./GradeIncreaseConfirmModal";

const GradeIncreaseButton = () => {
  const dispatch = useDispatch();
  const { allStudents, loading } = useSelector((state) => state.student);

  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [eligibleStudents, setEligibleStudents] = useState([]);

  const isMobile =
    Math.min(window.innerWidth, window.screen.width) <= 768;

  const handleButtonClick = () => {
    const eligible = allStudents.filter((s) => s.grade < 12);
    if (eligible.length === 0) {
      alert("증가할 학년의 학생이 없습니다.");
      return;
    }
    setEligibleStudents(eligible);
    setIsPreviewModalOpen(true);
  };

  const handlePreviewConfirm = () => {
    setIsPreviewModalOpen(false);
    setIsConfirmModalOpen(true);
  };

  const handlePreviewCancel = () => {
    setIsPreviewModalOpen(false);
    setEligibleStudents([]);
  };

  const handleFinalConfirm = async () => {
    const result = await dispatch(bulkIncreaseStudentGrade());
    if (bulkIncreaseStudentGrade.fulfilled.match(result)) {
      alert(`총 ${eligibleStudents.length}명의 학년이 증가되었습니다.`);
      setIsConfirmModalOpen(false);
      setEligibleStudents([]);
      dispatch(fetchStudents());
    } else {
      alert("학년 증가 중 오류가 발생했습니다. 다시 시도해주세요.");
    }
  };

  const handleFinalCancel = () => {
    setIsConfirmModalOpen(false);
  };

  return (
    <>
      <button
        style={{
          padding: isMobile ? "8px 12px" : "10px 18px",
          backgroundColor: "#F4F8F7",
          color: "#3A434E",
          border: "none",
          borderRadius: "999px",
          cursor: loading ? "not-allowed" : "pointer",
          fontSize: "0.86rem",
          fontWeight: 700,
          fontFamily: "inherit",
          whiteSpace: "nowrap",
          opacity: loading ? 0.5 : 1,
          transition: "background-color .12s, color .12s",
        }}
        onClick={handleButtonClick}
        disabled={loading}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = "#E5FBF8";
          e.currentTarget.style.color = "#00A396";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = "#F4F8F7";
          e.currentTarget.style.color = "#3A434E";
        }}
      >
        학년 일괄 증가
      </button>

      {isPreviewModalOpen && (
        <GradeIncreasePreviewModal
          students={eligibleStudents}
          onConfirm={handlePreviewConfirm}
          onCancel={handlePreviewCancel}
        />
      )}

      {isConfirmModalOpen && (
        <GradeIncreaseConfirmModal
          onConfirm={handleFinalConfirm}
          onCancel={handleFinalCancel}
        />
      )}
    </>
  );
};

export default GradeIncreaseButton;
